// extracted by mini-css-extract-plugin
export default {"innerContent":"TermsAndConditions_innerContent__6UtvA","terms":"TermsAndConditions_terms__NBIu9","iframe":"TermsAndConditions_iframe__-SNLr"};